export var BasicSettings = {
    lineTension: 0.4,
    pointRadius: 1,
    pointHoverRadius: 5,
    pointHitRadius: 10,
};
